export function initTextOverride() {
    window.ContentEdit.Text.prototype._keyReturn = function (ev) {
        var element, insertAt, lineBreakStr, selection, tail, tip;
        ev.preventDefault();
        if (this.content.isWhitespace() && !ev.shiftKey ^ window.ContentEdit.PREFER_LINE_BREAKS) {
            return;
        }
        selection = window.ContentSelect.Range.query(this._domElement);
        tip = this.content.substring(0, selection.get()[0]);
        tail = this.content.substring(selection.get()[1]);
        if (ev.shiftKey ^ window.ContentEdit.PREFER_LINE_BREAKS) {
            insertAt = selection.get()[0];
            lineBreakStr = '<br>';
            if (this.content.length() === insertAt) {
                if (this.content.length() === 0 || !this.content.characters[insertAt - 1].isTag('br')) {
                    lineBreakStr = '<br><br>';
                }
            }
            this.content = this.content.insert(insertAt, new window.HTMLString.String(lineBreakStr, true), true);
            this.updateInnerHTML();
            insertAt += 1;
            selection = new window.ContentSelect.Range(insertAt, insertAt);
            selection.select(this.domElement());
            this.taint();
            return;
        }
        if (!this.can('spawn')) {
            return;
        }
        this.content = tip;
        this.updateInnerHTML();
        element = new this.constructor('p', {}, tail);
        this.parent().attach(element, this.parent().children.indexOf(this) + 1);
        if (tip.length()) {
            element.focus();
            selection = new window.ContentSelect.Range(0, 0);
            selection.select(element.domElement());
        } else {
            selection = new window.ContentSelect.Range(0, tip.length());
            selection.select(this._domElement);
        }
        return this.taint();
    };
}
